let checkbox = document.getElementById('accept-note');
let cartNote = document.getElementById('Cart-Note');

if (checkbox && cartNote) {
  checkbox.addEventListener('click', () => {
    if (checkbox.checked) {
      cartNote.innerText += "With Invoice Printout: true"; 
    } else {
      cartNote.innerText = cartNote.innerText.replace("with Invoice Printout: true", "");
    }
  });
}

const $progressbar = document.querySelector(".progress_variant_progressbar");
if ($progressbar && $progressbar.parentElement) {
  const $radioInputs = $progressbar.parentElement.querySelectorAll("input[type='radio']");
  for (const $radioInput of $radioInputs) {
    let progressIndex = $radioInput.getAttribute("data-progress-index");
    if (!progressIndex) {
      continue;
    }

    progressIndex = parseInt(progressIndex);
    if (isNaN(progressIndex)) {
      continue;
    }

    if ($radioInput.checked) {
      let width = 33.33 * (progressIndex + 1);
      $progressbar.style.setProperty("--progressbar-width", `${width}%`);

      const $ticks = $progressbar.parentElement.querySelectorAll(".progress_variant_progressbar_tick");
      for (let i = 0; i < $ticks.length; i++) {
        const $tick = $ticks[i];
        if (i <= progressIndex) {
          $tick.classList.add("highlighted");
        } else {
          $tick.classList.remove("highlighted");
        }
      }

      const $labels = $progressbar.parentElement.querySelectorAll(".progress_variant_progressbar_label");
      if (progressIndex >= 2) {
        $labels[0].style.display = "none";
        $labels[1].querySelector(".progress_save").style.display = "none";
        $labels[1].querySelector(".progress_saved").style.display = "block";
      } else if (progressIndex == 1) {
        delete $labels[0].style.display;
        $labels[0].querySelector(".progress_save").style.display = "none";
        delete $labels[0].querySelector(".progress_saved").style.display;
        delete $labels[1].querySelector(".progress_save").style.display;
        $labels[1].querySelector(".progress_saved").style.display = "none";
      } else {
        delete $labels[0].style.display;
        delete $labels[1].style.display;
        delete $labels[0].querySelector(".progress_save").style.display;
        $labels[0].querySelector(".progress_saved").style.display = "none";
        delete $labels[1].querySelector(".progress_save").style.display;
        $labels[1].querySelector(".progress_saved").style.display = "none";
      }

      break;
    }
  }
}